module.exports = __webpack_public_path__ + "img/12.0eb87007.jpg";